import { Component, computed, signal, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../store/app/app.selectors';
import { AsyncPipe } from '@angular/common';
import { ToggleSideNav } from '../../../store/app/app.actions';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Tasks } from '../../../_interfaces/tasks.interface';
import { TasksApiService } from '../../../_services/tasks-api-service/tasks-api.service';
import { TasksDropdownComponent } from '../tasks-dropdown/tasks-dropdown.component';
import { ProfileDropdownComponent } from '../profile-dropdown/profile-dropdown.component';
import { ResponsiveService } from '../../../_services/responsive-service/responsive.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-header',
  imports: [AsyncPipe, NgbDropdownModule, TasksDropdownComponent, ProfileDropdownComponent],
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);
  readonly store = inject(Store);
  readonly tasksApiService = inject(TasksApiService);
  readonly responsiveService = inject(ResponsiveService);

  readonly userProfile$ = this.store.select(AppSelectors.userDetails);
  readonly hasNavigationAccess$ = this.store.select(AppSelectors.hasNavigationAccess);
  readonly hasNavigationAccess = toSignal(this.hasNavigationAccess$, { initialValue: false });

  protected pageTitle!: Observable<string>;
  protected tasks = signal<Tasks | undefined>(undefined);
  protected readonly isMobile = this.responsiveService.isMobile;
  protected taskCount = computed(() => {
    const currentTasks = this.tasks();
    if (!currentTasks) return 0;

    return Object.values(currentTasks)
      .map<boolean>((task) => task.display)
      .filter(Boolean).length; // Count `true` values
  });

  constructor() {
    this.pageTitle = this.store.select(AppSelectors.title);
    this.fetchTasks();
  }

  onSideNavToggleClicked(): void {
    this.store.dispatch(new ToggleSideNav());
  }

  private fetchTasks() {
    this.tasksApiService.getAllTasks().subscribe({
      next: (res) => {
        this.tasks.set(res); // Update the tasks signal
      },
    });
  }
}
